import DOMPurify from 'dompurify';

/**
 * Sanitises user-submitted HTML content to prevent XSS attacks.
 *
 * Mirrors the server-side `sanitizeHtml` in server/src/utils/sanitize.ts.
 * DOMPurify removes scripts, event handlers, and other dangerous
 * HTML/CSS while preserving safe formatting tags (headings, lists,
 * bold, italic, links, etc.).
 *
 * Returns the input unchanged if it's not a string (null, undefined, etc.)
 * or if it doesn't contain any HTML tags.
 */
export function sanitizeHtml(input: string | null | undefined): string {
  if (input == null || typeof input !== 'string') return '';
  if (!/<[a-zA-Z][^>]*>/.test(input)) return input; // skip plain text
  return DOMPurify.sanitize(input);
}
